import {
  ACTIVE_DESIGN_SYSTEM_VERSION,
  getDesignSystem,
} from '../../../../../layouts/theme/designSystem';
import type {DesignSystemVersion} from '../../../../../layouts/theme/designSystem';

export const getCulturalAlignmentColors = (
  version: DesignSystemVersion = ACTIVE_DESIGN_SYSTEM_VERSION,
) => {
  const {alignmentStatus, greenColors, neutral, orangeColors, scorePill} = getDesignSystem(version);

  const cultureTypeChip = {
    bgcolor: scorePill.high.bgcolor,
    color: scorePill.high.color,
  };

  const overallAlignmentGradient =
    `linear-gradient(90deg, ${scorePill.high.strokeColor}, ${scorePill.high.bgcolor})`;

  return {
    companyMarker: alignmentStatus.metAccent,
    profileMarker: version === 'monochrome' ? greenColors[500] : orangeColors[900],
    applicantAvgMarker: scorePill.medium.strokeColor,
    cultureTypeChip,
    overallAlignmentGradient,
    scaleStepMarker: version === '20260616' ? greenColors[40] : neutral[300],
    overlapZone: version === '20260616' ? neutral[700] : neutral[600],
    badge: {
      aligned: {color: alignmentStatus.metChipFg, bgcolor: alignmentStatus.metChipBg},
      close: {color: alignmentStatus.metChipFg, bgcolor: scorePill.high.bgcolor},
      moderate: {color: alignmentStatus.warningChipFg, bgcolor: alignmentStatus.warningChipBg},
      different: {color: alignmentStatus.gapChipFg, bgcolor: alignmentStatus.gapChipBg},
    },
  } as const;
};

export const culturalAlignmentColors = getCulturalAlignmentColors();
